import { useMutation, useQueryClient } from '@tanstack/react-query';
import { projectDataClient } from '../../../lib/connect/clients';
import { invalidatePursuitReads } from './pursuitQueryKeys';
/**
 * GRW-04: link the program this pursuit recompetes. `requestId` is minted by
 * the dialog once per open and re-sent on retry, so a retried link never
 * makes a second row (the server is idempotent on it). Success refetches the
 * header (contract clock, current contracts, context line), the thread and
 * the record's linked chips.
 */ export function useLinkPursuitRecompete() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (args)=>projectDataClient.linkPursuitRecompete(args),
        onSuccess: async ()=>{
            await Promise.all([
                invalidatePursuitReads(queryClient),
                queryClient.invalidateQueries({
                    queryKey: [
                        'lifecycleChips'
                    ]
                })
            ]);
        }
    });
}
/**
 * GRW-04 v2.1 (OD-19): whether readers of the recompeted program may see the
 * content-free "Growth is working this" hint. Invalidates the header (its
 * `showGrowthHintToDelivery`) and the linked chips (the program's hint).
 */ export function useSetPursuitGrowthHint() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (args)=>projectDataClient.setPursuitGrowthHint(args),
        onSuccess: async ()=>{
            await Promise.all([
                invalidatePursuitReads(queryClient),
                queryClient.invalidateQueries({
                    queryKey: [
                        'lifecycleChips'
                    ]
                })
            ]);
        }
    });
}
/**
 * GRW-04 `OpenRecompetePursuit`, used by Growth Home's "Open a pursuit"
 * (GRW-22): opens a pursuit for a program we deliver and links it, retry-safe
 * on `requestId` (minted once per item). Refetches Growth Home and the lists.
 */ export function useOpenRecompetePursuit() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (args)=>projectDataClient.openRecompetePursuit({
                programId: args.programId,
                requestId: args.requestId
            }),
        onSuccess: async ()=>{
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: [
                        'growth-home-work'
                    ]
                }),
                queryClient.invalidateQueries({
                    queryKey: [
                        'pursuits'
                    ]
                })
            ]);
        }
    });
}
